<div class="blank-slate theming-icon"
[inlineSVG]="svgPath" 
[setSVGAttributes]="svgAttrs"></div>